module.exports = __webpack_public_path__ + "static/media/en.0be92352.svg";